import WrapperElementPropsType from "../../types/component/WrapperElementPropsType";

export default function ChapterText(props: WrapperElementPropsType) {
    return <p className={"text-lobcv-blue-600 text-lg " + props.className}>{props.children}</p>
}
